import {
  createNameSet,
  createRendererSet,
  createSpecSet,
  Link,
  link,
  PersonName,
  personName,
  renderLink,
  renderPersonName,
} from "@resource/atlas/content-editor/variables";

import {
  guideBaseNameSet,
  guideBaseRendererSet,
  guideBaseSpecSet,
  GuideBaseVariableSet,
} from "../base/variables";

// set type
// --------

export type GuideUpdateVariableSet = GuideBaseVariableSet & {
  authorName: PersonName;
  codesignalTestAssessmentLink: Link;
};

// renderer set
// ------------

export const guideUpdateRendererSet = createRendererSet<GuideUpdateVariableSet>(
  {
    ...guideBaseRendererSet,
    authorName: renderPersonName,
    codesignalTestAssessmentLink: renderLink,
  }
);

// name set
// --------

export const guideUpdateNameSet = createNameSet<GuideUpdateVariableSet>({
  ...guideBaseNameSet,
  authorName: { name: "author.name", label: "Message author's full name" },
  codesignalTestAssessmentLink: {
    name: "codesignal.testAssessmentLink",
    label: "CodeSignal test assessment link",
  },
});

// spec set
// --------

export const guideUpdateSpecSet = createSpecSet<GuideUpdateVariableSet>(
  {
    ...guideBaseSpecSet,
    authorName: personName(),
    codesignalTestAssessmentLink: link(),
  },
  { rendererSet: guideUpdateRendererSet, nameSet: guideUpdateNameSet }
);
